import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import ErrorBoundary from './components/ErrorBoundary';

// CRITICAL: Set up error filtering BEFORE anything else loads
// This must run before React initializes to catch extension errors early

// Helper function to check if error is from browser extension
const isExtensionError = (errorMessage, errorSource = '') => {
  const message = errorMessage || '';
  const source = errorSource || '';
  
  return (
    (message.includes('Request timeout') && 
     (message.includes('Distributor') || 
      message.includes('appSettingsDistributor') ||
      message.includes('lettersVoicesDistributor') ||
      message.includes('dictionariesDistributor') ||
      message.includes('availableLanguagesDistributor') ||
      message.includes('availableTextCheckLanguagesDistributor') ||
      message.includes('dictateStateDistributor') ||
      message.includes('predictionDistributor') ||
      message.includes('speechVoicesDistributor') ||
      message.includes('userDistributor') ||
      message.includes('wordsDistributor') ||
      message.includes('textCheckersDistributor') ||
      message.includes('topicsDistributor') ||
      message.includes('getDictionariesByLanguageId') ||
      message.includes('isMathOcrAvailable') ||
      message.includes('isPredictionAvailable') ||
      message.includes('isDictateAvailable') ||
      message.includes('DefineExpirationForLanguagePacks') ||
      message.includes('getValue'))) ||
    (message.includes('Distributor') && (message.includes('bundle.js') || source.includes('bundle.js'))) ||
    message.includes('ERR_BLOCKED_BY_CLIENT') ||
    message.includes('Tracking Prevention blocked') ||
    message.includes('adsbygoogle') ||
    message.includes('pagead2.googlesyndication.com') ||
    message.includes('Performance measurement service is not available') ||
    message.includes('initializePerformanceMeasurementService') ||
    // Filter extension gallery and chrome:// URL errors
    message.includes('The extensions gallery cannot be scripted') ||
    message.includes('Cannot access chrome:// and edge:// URLs') ||
    message.includes('background-remote-executor') ||
    // Filter beforeinstallprompt warnings (we handle this ourselves)
    message.includes('Banner not shown: beforeinstallprompt')
  );
};

// Filter out browser extension errors from console
const originalError = console.error;
const originalWarn = console.warn;
console.error = (...args) => {
  const errorMessage = args.join(' ');
  if (isExtensionError(errorMessage)) {
    // Silently ignore extension errors
    return;
  }
  originalError.apply(console, args);
};

// Also filter warnings for performance measurement
console.warn = (...args) => {
  const warnMessage = args.join(' ');
  if (isExtensionError(warnMessage)) {
    return;
  }
  originalWarn.apply(console, args);
};

// Filter out browser extension errors from window error handler
// Use capture phase to catch errors before React sees them
window.addEventListener('error', (event) => {
  const errorMessage = event.message || '';
  const errorSource = event.filename || event.source || '';
  
  if (isExtensionError(errorMessage, errorSource)) {
    event.preventDefault();
    event.stopPropagation();
    return false;
  }
}, true); // Use capture phase

// Filter out unhandled promise rejections from extensions
window.addEventListener('unhandledrejection', (event) => {
  const errorMessage = event.reason?.message || String(event.reason) || '';
  
  if (isExtensionError(errorMessage)) {
    event.preventDefault();
    return false;
  }
});

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </React.StrictMode>
);
